import { type FC } from 'react';

import { type TopBarNotificationType } from 'constants/notifications';

import { Context25ActionButton } from './components/Context25ActionButton';
import { Context25CloseButton } from './components/Context25CloseButton';
import { Context25Message } from './components/Context25Message';
import { CONTEXT_25_CAMPAIGN } from './constants/context25-campaign';
import { createContext25UtmUrl } from './helpers/context25-url';
import { useContext25Interactions } from './hooks/use-context25-interactions';

import * as styles from './styles';

interface Props {
  onSkip(name: TopBarNotificationType): void;
  name: TopBarNotificationType;
  isVisible: boolean;
}

export const Context25CampaignBar: FC<Props> = ({ onSkip, name, isVisible }) => {
  const { handleSkip, handleSaveTheDate } = useContext25Interactions({
    name,
    onSkip,
    isVisible,
    utmParams: CONTEXT_25_CAMPAIGN.utmParams,
  });

  const targetUrl = createContext25UtmUrl(CONTEXT_25_CAMPAIGN.utmParams);

  return (
    <section className={styles.bannerStyle(isVisible)} aria-label="Context 25 campaign banner" aria-hidden={!isVisible}>
      <div className={styles.contentStyle}>
        <Context25Message />
        <Context25ActionButton onClick={() => handleSaveTheDate(targetUrl)} />
      </div>
      <Context25CloseButton onClick={handleSkip} />
    </section>
  );
};
